import {useApiManager} from "../../../../components/utils/api";

import React, {useEffect, useState} from "react";

import {Box, TextField} from "@mui/material";
import {FilterChips, Page, PageHeader, SkeletonRows} from "../../../../components/kit";

import {OccupationGroup} from "./occupation_group";
import {OccupationIndividual} from "./occupation_individual";
import {useSearchParams} from "react-router-dom";
import {Occupation, OccupationRestControllerApiFactory} from "arteco-api-client-ts";



export const OccupationPage = () => {
	const apiManager = useApiManager();
	const [searchParams, setSearchParams] = useSearchParams();

	const occupationCtrl = apiManager.factory(OccupationRestControllerApiFactory);

	const [occupation, setOccupation] = useState<Occupation | undefined>();

	// Por defecto se abre el mes pasado, que es el que se está facturando.
	const prevMonthDate = new Date();
	prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

	// Mes, año y pestaña viven en la URL para poder compartir y recargar sin perder el sitio.
	const selectedMonth = searchParams.get("month") || (prevMonthDate.getMonth() + 1).toString();
	const year = parseInt(searchParams.get("year") || "") || prevMonthDate.getFullYear();
	const selectedMainTab = searchParams.get("tab") || "group";

	// El campo de año se edita libremente y sólo se aplica al confirmar: si se aplicara en cada
	// tecla, escribir "2025" dispararía cuatro peticiones del año completo (y un NaN al vaciarlo).
	const [yearDraft, setYearDraft] = useState<string>(year.toString());

	useEffect(() => setYearDraft(year.toString()), [year]);

	const setParam = (name: string, value: string): void => {
		const next = new URLSearchParams(searchParams);
		next.set(name, value);
		setSearchParams(next, {replace: true});
	};

	const monthsNames = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

	useEffect(() => {
		setOccupation(undefined);
		apiManager.execute(occupationCtrl.occupation(undefined, year))
		.then(occupation => setOccupation(occupation));
	}, [year]);

	const applyYearDraft = (): void => {
		const parsed = parseInt(yearDraft);
		if (isNaN(parsed) || parsed < 2000 || parsed > 2100) {
			setYearDraft(year.toString());
			return;
		}
		if (parsed !== year) {
			setParam("year", parsed.toString());
		}
	};

	const changeMonth = (month: string): void => {
		setParam("month", month);
	}


	const monthLong = new Date(year, parseInt(selectedMonth) - 1, 1).toLocaleDateString("es-ES", {month: "long"});

	return (
		<Page maxWidth={1600}>
			<PageHeader title="Cuadro de ocupación"
						subtitle={`${monthLong.charAt(0).toUpperCase() + monthLong.substring(1)} de ${year}: dedicaciones, imputación y facturación del mes.`}
						actions={<TextField sx={{width: "7em"}}
											label={"Año"}
											value={yearDraft}
											type={"number"}
											size={"small"}
											onChange={(e) => setYearDraft(e.target.value)}
											onBlur={applyYearDraft}
											onKeyDown={(e) => {
												if (e.key === "Enter") {
													applyYearDraft();
												}
											}}/>}/>

			<Box sx={{display: "flex", flexDirection: {xs: "column", md: "row"}, gap: 1.5, justifyContent: "space-between", mb: 2}}>
				<FilterChips value={selectedMonth} onChange={changeMonth}
							 options={monthsNames.map((monthName, idx) => ({value: (idx + 1).toString(), label: monthName}))}/>
				<FilterChips value={selectedMainTab} onChange={v => setParam("tab", v)}
							 options={[{value: "group", label: "Grupal"}, {value: "individual", label: "Individual"}]}/>
			</Box>

			{!occupation && <SkeletonRows rows={6}/>}
			{occupation && selectedMainTab === "group" && (
				<OccupationGroup occupation={occupation} year={year} month={selectedMonth}/>
			)}
			{occupation && selectedMainTab !== "group" && (
				<OccupationIndividual occupation={occupation} year={year} month={selectedMonth}/>
			)}
		</Page>
	);
};
